import { render, staticRenderFns } from "./footprintMain.vue?vue&type=template&id=1bc0810e&scoped=true&"
import script from "./footprintMain.vue?vue&type=script&lang=js&"
export * from "./footprintMain.vue?vue&type=script&lang=js&"
import style0 from "./footprintMain.vue?vue&type=style&index=0&id=1bc0810e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0810e",
  null
  
)

export default component.exports